'use strict';

exports.__esModule = true;
exports['default'] = reorderKeys;

var hasWarned = false;

function reorderKeys() {
  if (process.env.NODE_ENV === 'development') {
    if (!hasWarned) {
      hasWarned = true;
      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
    }
  }
}

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-motion/lib/reorderKeys.js
 ** module id = 3388
 ** module chunks = 0
 **/